import React, { useEffect, useState } from 'react';
import {
  ILearningCenterCategoryTile,
  ILearningCenterTilesSectionFields
} from '../../../../../types/contentful';
import { CategoryTile } from './CategoryTile';
import { useMediaQuery } from '../../../../hooks/useMediaQuery';
import { LinearGradientToken } from '../../../../theme/tokens/linear-gradient';

function getTileColor(tileIndex: number) {
  const colors: LinearGradientToken[] = [
    'HIBISCUS',
    'YELLOW',
    'TEAL',
    'NAVY',
    'VIOLET',
    'BLUE',
    'MINT',
    'VIOLET',
    'NAVY',
    'BLUE',
    'YELLOW',
    'HIBISCUS'
  ];
  const colorIndex = tileIndex % colors.length;

  return colors[colorIndex];
}

export function TilesSection({
  tiles,
  maxNumberOfRows
}: ILearningCenterTilesSectionFields) {
  const isDesktop = useMediaQuery('desktop');
  const [tilesList, setTilesList] = useState<ILearningCenterCategoryTile[]>([]);

  useEffect(() => {
    const tilesPerRow = isDesktop ? 6 : 2;
    const autoRowsNumber = isDesktop ? 2 : 3;
    const tilesLimit = (maxNumberOfRows ?? autoRowsNumber) * tilesPerRow;
    setTilesList(tiles.slice(0, tilesLimit));
  }, [isDesktop]);

  return (
    <div
      className="block-container layout-padding -mt-[50px] p-0 tablet:-mb-[90px] tablet:-mt-[70px]"
      data-testid="tiles-section"
    >
      <div className="grid max-w-[1366px] grid-cols-2 content-center items-center justify-center gap-x-4 gap-y-6 tablet:w-full tablet:grid-cols-4 desktop:grid-cols-6 desktop:justify-start">
        {tilesList.map(({ sys, fields }, index) => (
          <CategoryTile key={sys.id} color={getTileColor(index)} {...fields} />
        ))}
      </div>
    </div>
  );
}
